import useAppointmentSummary from "../../hooks/useAppointmentSummary";
const AppointmentSummary = () => {
  const { appointment, loading, onBackClick } = useAppointmentSummary();

  if (loading) return <div className="p-4">Loading appointment summary...</div>;
  if (!appointment) return <div className="p-4">No appointment found.</div>;
  return (
    <div
      className="summary-appointment max-w-lg mx-auto mt-16 text-center 
    "
    >
      {/* Success icon */}
      <div
        className="w-20 h-30 p-2 mx-auto flex items-center justify-center rounded-full text-white text-4xl mb-6"
        style={{ backgroundColor: "var(--primary-color)" }}
      >
        <i className="fa-notdog-duo fa-solid fa-check fa-lg fa-beat"></i>
      </div>

      <h2 className="text-3xl font-semibold mb-2 p-3">Appointment Confirmed</h2>

      <p className="text-muted mb-8">
        Your booking has been successfully scheduled.
      </p>

      {/* Appointment summary */}
      <div className="card p-6 text-left m-3 p-3">
        <div className="flex justify-between mb-3">
          <span className="text-muted me-2">Staff</span>
          <span className="font-medium">{appointment.staffName}</span>
        </div>

        <div className="flex justify-between mb-3">
          <span className="text-muted">Date</span>
          <span className="font-medium">
            {new Date(appointment.date).toLocaleDateString()}
          </span>
        </div>

        <div className="flex justify-between mb-4">
          <span className="text-muted">Time</span>
          <span className="font-medium">
            {appointment.startTime.split(":").slice(0, 2).join(":")}
          </span>
        </div>

        <div className="border-t pt-4">
          <p className="font-medium  m-0 services-list-title ">Services</p>

          <ul className="list-group services-list space-y-1">
            {appointment.services.map((service) => (
              <li key={service.id} className="list-group-item">
                {service.quantity > 1 ? `${service.quantity}x ` : ""}
                {service.name}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Reference code */}
      <div className="p-3 Reference-code rounded-lg mb-4">
        <p className="text-sm text-light mb-1">Booking Reference</p>

        <p className="text-xl font-semibold tracking-wider">
          {appointment.refferenceCode}
        </p>
      </div>

      {/* Action */}
      <button
        onClick={() => onBackClick()}
        className="btn btn-primary px-6 py-3 rounded-lg mb-4"
      >
        New Appointment
      </button>
    </div>
  );
};

export default AppointmentSummary;
